// Icônes de l'interface : un fichier par nom dans public/assets/icons (SVG ou PNG), remplaçable à volonté.
// Un SVG en `currentColor` prend la couleur du texte ; une image en couleurs s'affiche telle quelle.

export const ICON_NAMES = [
  'close', 'help', 'info', 'quests', 'ranking', 'pokedex', 'team', 'bag', 'logout', 'chat', 'sound-on', 'sound-off', 'coins',
  'badge', 'appearance', 'shop', 'storage', 'box', 'heal', 'heart', 'sparkles', 'sword', 'flag', 'flee', 'capture', 'switch', 'energy',
  'rest', 'star', 'follow', 'rename', 'summary', 'stats', 'check', 'target', 'trash', 'plus', 'minus', 'chevron-up',
  'chevron-down', 'chevron-left', 'chevron-right', 'arrow-up', 'arrow-down', 'arrow-left', 'arrow-right', 'zone', 'home',
  'chest', 'lock', 'warp', 'npc', 'trainer', 'mail', 'external-link', 'warning', 'gift', 'crown', 'trophy', 'duel', 'user',
  'users', 'map', 'elements', 'monster', 'moves', 'gamepad', 'brush', 'fill', 'object', 'spawn', 'undo', 'redo', 'save',
  'blocked', 'animated', 'link', 'pipette', 'cursor', 'copy', 'paste', 'mirror', 'critical', 'grass', 'hourglass', 'search', 'eye', 'image', 'run', 'light', 'skates', 'rain', 'moon', 'sun', 'snow', 'fog',
  'type-normal', 'type-fire', 'type-water', 'type-grass', 'type-electric', 'type-rock', 'type-ghost', 'type-astral',
  'type-ice', 'type-fighting', 'type-toxic', 'type-air', 'menu',
  'item-capsule', 'item-super-capsule', 'item-hyper-capsule', 'item-potion', 'item-super-potion', 'item-disc',
] as const;
export type IconName = (typeof ICON_NAMES)[number];

export const ICON_URL = '/assets/icons/';

export const isIconName = (value: unknown): value is IconName => typeof value === 'string' && (ICON_NAMES as readonly string[]).includes(value);

/**
 * Icône glissée dans un texte envoyé au client (notification, journal de combat…) : `[[nom]]`,
 * remplacée par l'icône à l'affichage.
 */
export const iconToken = (name: IconName): string => `[[${name}]]`;
export const ICON_TOKEN = /\[\[([a-z0-9-]+)\]\]/g;

/** Texte sans ses jetons d'icône (pour un attribut `title`, une option de liste…). */
export const stripIconTokens = (text: string): string => text.replace(ICON_TOKEN, '').replace(/\s{2,}/g, ' ').trim();
